import React from "react";
import SubscriptionActivityTimeline from "../SubscriptionActivityTimeline";

const SubscriptionActivityTab = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-base font-semibold text-gray-900">Activity</h2>
        <p className="text-xs text-gray-500 mt-0.5">
          Subscription and billing activity timeline
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
        <div className="p-6 sm:p-8">
          <SubscriptionActivityTimeline />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionActivityTab;
